import { useState } from 'react';
import { ActionIcon, Group, Stack, Text, TextInput } from '@cowbell/ui/core';
import {
  useShellAgents,
  useShellDrawer,
  useShellSelection,
} from '../../provider';
import { AgentGroupList } from './AgentGroupList';
import { groupAgents } from './agent-groups';
import { ArrowLeftIcon } from './icons';

/** Expanded "all agents" view. Reached via "Browse all agents" from the
 *  default view. Back arrow returns to default. */
export function AllAgentsView() {
  const agents = useShellAgents();
  const drawer = useShellDrawer();
  const selection = useShellSelection();
  const [search, setSearch] = useState('');

  const filteredIds = agents.allIds.filter((id) => {
    const agent = agents.byId[id];
    return (
      !agent ||
      search === '' ||
      agent.name.toLowerCase().includes(search.toLowerCase())
    );
  });

  const handleSelect = (agentId: string) => {
    selection.selectAgent(agentId);
    drawer.close();
  };

  return (
    <Stack gap="xs" p="md">
      <Group gap="xs">
        <ActionIcon
          variant="subtle"
          aria-label="Back"
          onClick={() => drawer.setView('default')}
        >
          <ArrowLeftIcon />
        </ActionIcon>
        <Text fw={600}>All agents</Text>
      </Group>
      <TextInput
        aria-label="Search agents"
        placeholder="Search agents…"
        value={search}
        onChange={(e) => setSearch(e.currentTarget.value)}
        size="xs"
      />
      <AgentGroupList
        groups={groupAgents(filteredIds, agents.byId)}
        byId={agents.byId}
        selectedId={selection.agentId}
        onSelect={handleSelect}
      />
    </Stack>
  );
}
